/**
 * Convert a string from snake_case to camelCase
 * @param str: string
 */
export const convertSnakeToCamelCase = (str: string) => {
  return str.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '')
  })
}
